module.exports = __webpack_public_path__ + "media/images/empresa/emp_creditos-01cfde4c37381f039498e66974d62ba8.svg";